/**
 * Whether "Upgrade to Pro" should first ask "Is this the right account?".
 *
 * Pro applies only to the account ChatGPT and the device are connected to. People who pay on another
 * account stay blocked, and nothing links the two accounts. An account with no devices, or with no
 * tool calls this month, is the one signal the dashboard has that it may not be the one in use.
 */
export interface UpgradeAccountCheck {
    noDevices: boolean;
    noCalls: boolean;
}

/**
 * The device count to check, or null while it is unknown: before the first successful read, and
 * after a failed one. Both leave the device list empty, which must not read as "no devices".
 */
export function knownDeviceCount(known: boolean, devices: readonly unknown[]): number | null {
    return known ? devices.length : null;
}

/** Pass null for a count that has not loaded: an unknown count never holds checkout. */
export function upgradeAccountCheck(deviceCount: number | null, callsThisMonth: number | null): UpgradeAccountCheck | null {
    const noDevices = deviceCount === 0;
    const noCalls = callsThisMonth === 0;
    return noDevices || noCalls
        ? {
              noDevices,
              noCalls,
          }
        : null;
}

/** The line under the account in the dialog, naming only the signals that apply. */
export function accountCheckReason({ noDevices, noCalls }: UpgradeAccountCheck): string {
    if (noDevices && noCalls) {
        return "No devices connected and no tool calls this month";
    }
    return noDevices ? "No devices connected" : "No tool calls this month";
}
